/* Web Affiliate 1.8.0. No dependencies, pixels, polling or calls to CS-Cart while browsing. */
(function () {
    'use strict';
    var script = document.currentScript;
    var site = script && script.getAttribute('data-wa-site-id');
    if (!/^[1-9][0-9]*$/.test(site || '')) { return; }
    var key = 'web_affiliate_' + site;
    var attribute = '__wa_attribution';
    var incoming = new URL(location.href).searchParams.get('wa_token') || '';
    var current = '', written = null, busy = Promise.resolve(), checkoutReplay = false;

    function read(token) {
        var match = /^1\.([1-9][0-9]*)\.([1-9][0-9]*)\.([0-9]{10})\.([0-9]{10})\.([FL])\.([a-f0-9]{16})\.([a-f0-9]{64})$/.exec(token || '');
        if (!match || match[1] !== site || Number(match[4]) <= Date.now() / 1000) { return null; }
        // Client parsing is only for persistence. CS-Cart verifies the signature against order creation time.
        return { token: token, policy: match[5] };
    }
    function allowed() {
        return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.marketingAllowed());
    }
    function stored() {
        try { return localStorage.getItem(key) || ''; } catch (_) { return ''; }
    }
    function persist(token) {
        try { if (token) { localStorage.setItem(key, token); } else { localStorage.removeItem(key); } } catch (_) { /* Current visit still works. */ }
    }
    function sync() {
        busy = busy.catch(function () {}).then(function () {
            var token = allowed() && read(current) ? current : '';
            if (written === token) { return; }
            var attrs = {}; attrs[attribute] = token;
            var controller = new AbortController();
            var timeout = setTimeout(function () { controller.abort(); }, 1500);
            return fetch((Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
                method: 'POST', credentials: 'same-origin', signal: controller.signal,
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ attributes: attrs })
            }).then(function (response) {
                if (!response.ok) { throw new Error('cart_attribute_failed'); }
                written = token;
            }).finally(function () { clearTimeout(timeout); });
        });
        return busy;
    }
    function refresh() {
        if (!window.Shopify || !Shopify.customerPrivacy) { return; }
        var savedBefore = stored();
        if (!allowed()) {
            var hadToken = current || stored();
            current = ''; persist('');
            if (hadToken) { sync().catch(function () {}); }
            return;
        }
        var previous = read(current) || read(stored());
        var next = read(incoming);
        current = previous ? previous.token : '';
        if (next && (!previous || next.policy === 'L')) { current = next.token; }
        incoming = '';
        persist(current);
        if (current || savedBefore) { sync().catch(function () {}); }
        // Remove attribution from the visible URL only after it has been retained with permission.
        var url = new URL(location.href);
        if (url.searchParams.has('wa_token')) {
            url.searchParams.delete('wa_token');
            history.replaceState(history.state, '', url.href);
        }
    }
    function prepareCheckout(event, resume) {
        if (checkoutReplay || (!current && !written)) { return; }
        event.preventDefault(); event.stopImmediatePropagation();
        // Retry a failed cart write once at checkout; never hold the purchase indefinitely.
        sync().catch(function () {
            console.warn('Web Affiliate: attribuzione non salvata. Verificare il collegamento del tema.');
        }).finally(function () {
            checkoutReplay = true;
            try { resume(); } finally { checkoutReplay = false; }
        });
    }
    document.addEventListener('click', function (event) {
        var target = event.target.closest && event.target.closest('button[name="checkout"],input[name="checkout"],a[href]');
        if (!target) { return; }
        if (target.tagName === 'A') {
            var url = new URL(target.href, location.href);
            if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) { return; }
        }
        prepareCheckout(event, function () { target.click(); });
    }, true);
    document.addEventListener('submit', function (event) {
        var form = event.target;
        var action = new URL(form.action, location.href);
        if (action.origin !== location.origin || (!/\/checkout\/?$/.test(action.pathname) && !(event.submitter && event.submitter.name === 'checkout'))) { return; }
        prepareCheckout(event, function () { form.requestSubmit(event.submitter || undefined); });
    }, true);
    document.addEventListener('visitorConsentCollected', refresh);
    document.addEventListener('shopifyCustomerPrivacyApiLoaded', refresh);
    window.addEventListener('pageshow', refresh);
    if (window.Shopify && Shopify.customerPrivacy) { refresh(); }
    else if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) { refresh(); } });
    }
})();
